import { render, staticRenderFns } from "./ContactSheet.vue?vue&type=template&id=19affd42&scoped=true"
import script from "./ContactSheet.vue?vue&type=script&lang=js"
export * from "./ContactSheet.vue?vue&type=script&lang=js"
import style0 from "./ContactSheet.vue?vue&type=style&index=0&id=19affd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19affd42",
  null
  
)

export default component.exports